import React from 'react';
import AppTypography from './AppTypography';
import styles from './AppRadioButton.module.css';

interface AppRadioButtonProps {
  label: string | React.ReactNode;
  selected: boolean;
  onPress: () => void;
  hasError?: boolean;
  disabled?: boolean;
  name?: string;
  value?: string;
  className?: string;
}

const AppRadioButton: React.FC<AppRadioButtonProps> = ({
  label,
  selected,
  onPress,
  hasError = false,
  disabled = false,
  name,
  value,
  className = '',
}) => {
  const classNames = [styles.container, className].filter(Boolean).join(' ');
  const radioClassNames = [styles.radioOuter, hasError ? styles.radioError : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={onPress}
      disabled={disabled}
      role="radio"
      aria-checked={selected}
      name={name}
      value={value}
    >
      <span className={radioClassNames} aria-hidden="true">
        {selected ? <span className={styles.radioInner} /> : null}
      </span>
      {typeof label === 'string' ? (
        <AppTypography className={styles.label}>{label}</AppTypography>
      ) : (
        <span className={styles.label}>{label}</span>
      )}
    </button>
  );
};

export default AppRadioButton;
